module.exports = __webpack_public_path__ + "elint-logo.png?f7f72f0b13b4764973faf0f7139463d2";